module.exports = __webpack_public_path__ + "img/GLT-logo.9e978d50.png";